import {
  Logout
} from '@/mixins'

export default {
  mixins: [
    Logout
  ],
  props: {
    value: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      dialog: false
    }
  },
  computed: {
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  mounted () {
    this.dialog = true
  },
  methods: {
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    confirmLogout () {
      this.isLoading = true

      this.logout()
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
